export enum policyDetailsType {
  All = 'all', // Policy Explorer
  Account = 'account',
  ParentAccount = 'parentAccount',
  Carrier = 'carrier',
  Wholesaler = 'wholesaler',
  CustomWholesaler = 'custom-wholesaler',
  Program = 'program'
}